// extracted by mini-css-extract-plugin
module.exports = {"addContact":"AddContact_addContact__3Ncc5","notFound":"AddContact_notFound__Qdvbh","result":"AddContact_result__1zbbd","item":"AddContact_item__3znmg"};